import { createFileRoute } from '@tanstack/react-router'

import { PortalProjectSpec } from '@/components/portal/portal-project-spec'
import { exactly, matching, readSearch, text } from '@/lib/search-params'

export const Route = createFileRoute('/portal/projets/$projectId')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /** #255 : la section du cahier ouverte dans le panneau (sa clé). */
        section: text(),
        /** #255 : le livrable ouvert dans le panneau (sa clé). */
        livrable: text(),
        /** 1.69.0 : l'onglet « Discussion » — l'adresse des courriels du fil. */
        onglet: exactly('discussion'),
        /** 1.76.0 : le chapitre qu'un courriel d'envoi désigne. */
        chapitre: matching(/^[0-9a-f]{24}$/),
      },
      search,
    ),
  component: PortalProjectRoute,
})

function PortalProjectRoute() {
  const { projectId } = Route.useParams()
  const { section, livrable, onglet, chapitre } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <PortalProjectSpec
      projectId={projectId}
      openSection={section}
      openDeliverable={livrable}
      focusChapter={chapitre}
      discussion={onglet === 'discussion'}
      onDiscussionChange={(open) => {
        void navigate({ search: open ? { onglet: 'discussion' } : {} })
      }}
      onClosePanel={() => {
        void navigate({ search: {} })
      }}
    />
  )
}
